<template>
  <div>
    <h2 class="text-h5 mb-4">
      Источники
    </h2>

    <analytics-filters
      v-model="filters"
      @apply="load"
    ></analytics-filters>

    <v-alert
      v-if="error"
      type="error"
      dense
      class="mb-4"
    >
      {{ error }}
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="50"
      class="elevation-0"
      hide-default-footer
    >
      <template #item.source="{ item }">
        <span :class="{ 'grey--text': item.source === 'direct / unknown' }">
          {{ item.source }}
        </span>
      </template>
      <template #item.revenue="{ item }">
        {{ formatMoney(item.revenue) }} ₽
      </template>
      <template #item.cr="{ item }">
        {{ item.cr }}%
      </template>
    </v-data-table>

    <v-alert
      type="info"
      text
      dense
      class="mt-4"
    >
      CR = купили / визиты. Визиты — сессии, лиды — успешные заявки,
      «пришли» и «купили» — уникальные клиенты.
      Строка <strong>direct / unknown</strong> — источник неизвестен.
    </v-alert>
  </div>
</template>

<script>
import Api from '@/api/api'
import AnalyticsFilters from './AnalyticsFilters.vue'

function stripEmpty(obj) {
  const out = {}
  Object.keys(obj || {}).forEach(k => {
    const v = obj[k]
    if (v !== '' && v !== null && v !== undefined) out[k] = v
  })
  return out
}

export default {
  name: 'AnalyticsSources',
  components: { AnalyticsFilters },
  data() {
    return {
      filters: {
        date_from: '',
        date_to: '',
        attribution: 'lead',
        source: '',
        campaign: '',
        company_id: null,
      },
      items: [],
      loading: false,
      error: null,
      headers: [
        { text: 'Источник', value: 'source' },
        { text: 'Визиты', value: 'visits', align: 'end' },
        { text: 'Лиды', value: 'leads', align: 'end' },
        { text: 'Пришли', value: 'came', align: 'end' },
        { text: 'Купили', value: 'buyers', align: 'end' },
        { text: 'CR', value: 'cr', align: 'end' },
        { text: 'Выручка', value: 'revenue', align: 'end' },
      ],
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    formatMoney(v) {
      return Number(v || 0).toLocaleString('ru-RU', {
        maximumFractionDigits: 0,
      })
    },
    async load() {
      this.loading = true
      this.error = null
      try {
        const data = await Api.getAnalyticsSources(stripEmpty(this.filters))
        this.items = data.items || []
      } catch (e) {
        this.error = 'Не удалось загрузить отчёт по источникам'
        this.items = []
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
